import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme } from '@mui/material';
import { FixedSizeList, areEqual } from 'react-window';
import memoize from 'memoize-one';
import InfiniteLoader from 'react-window-infinite-loader';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            paddingRight: theme.spacing(2),
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
    }),
);

interface RowProps {
    index: number;
    style: any;
    data: React.ReactNode[] | undefined;
}

const Row = memo((props: RowProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const classes = useStyles();
    const { index, style, data } = props;
    //const { items, onClick } = data;
    const row = data && data[index];

    return <div style={style}>{row}</div>;
}, areEqual);

const createItemData = memoize((items: React.ReactNode[]) => ({
    items,
}));

interface VirtualizedProps {
    items: React.ReactNode[];
    moreItemsLoading?: boolean;
    loadMore?: (startIndex: number, stopIndex: number) => void | Promise<void>;
    hasNextPage?: boolean;
    totalItemCount: number;
    searchInput?: string;
}

function VirtualizedList(props: VirtualizedProps) {
    //const {totalItemCount, loadMore} = props;

    const loadMore = props.loadMore;
    const itemData = createItemData(props.items);
    //const hasNextPage = props.hasNextPage;

    return (
        <div>
            {loadMore && itemData.items && (
                <>
                    <InfiniteLoader
                        isItemLoaded={(index) => index < itemData.items.length}
                        itemCount={props.totalItemCount}
                        loadMoreItems={loadMore}
                    >
                        {({ onItemsRendered, ref }) => (
                            <FixedSizeList
                                height={Math.min(
                                    700,
                                    itemData.items.length * 80,
                                )}
                                width={890}
                                itemSize={80}
                                itemCount={itemData.items.length}
                                overscanCount={1}
                                itemData={itemData.items}
                                onItemsRendered={onItemsRendered}
                                ref={ref}
                            >
                                {Row}
                            </FixedSizeList>
                        )}
                    </InfiniteLoader>
                </>
            )}
        </div>
    );
}

VirtualizedList.displayName = 'VirtualizedList';
export default VirtualizedList;
